import { render, staticRenderFns } from "./DdLogin.vue?vue&type=template&id=8f9a99de"
import script from "./DdLogin.vue?vue&type=script&lang=js"
export * from "./DdLogin.vue?vue&type=script&lang=js"
import style0 from "./DdLogin.vue?vue&type=style&index=0&id=8f9a99de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports